import React, { FC } from 'react'
import config from 'config'
import styles from './styles.module.scss'

interface SVGContainerProps {
  className: string
  height?: number
  width?: number
}

/**
 * Renders an SVG container.
 *
 * This simplifies layering various parts of the image above each other,
 * since these all share the same view box and preserve aspect ratio.
 */
export const SVGContainer: FC<SVGContainerProps> = ({
  children,
  className = '',
  width = config.mapWidth,
  height = config.mapHeight
}) => (
  <svg
    className={`${className} ${styles.svgContainer}`}
    viewBox={`0 0 ${width} ${height}`}
    preserveAspectRatio='xMidYMid meet'
  >
    {children}
  </svg>
)

export default SVGContainer
